export default __webpack_public_path__ + "static/media/obs_step3.beb2b131.png";